// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ilo5","col":"styles_col__20ZDS","actions":"styles_actions__3J5iN","conflict":"styles_conflict__1vm9m"};